module.exports = __webpack_public_path__ + "img/lifeskills.68236966.png";